'use client';

import { Checkbox } from '@paction-2.0/ui';

import styles from './readinessConsent.module.scss';

export function ReadinessConsent({
  checked,
  onChange,
  label,
  description
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description: string;
}) {
  return (
    <div className={styles.consent}>
      <Checkbox
        name="share-answers"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        label={label}
        description={description}
      />
    </div>
  );
}
